import * as enUS from './en-US';
import * as deDE from './de-DE';

export default {enUS, deDE};


/** WEBPACK FOOTER **
 ** ./src/translations/index.js
 **/